<template>
	<div class="lb-gemeinschaftsschule">
		<nk-title size="5xl" tag="h1" weight="norm">
			<span class="text-primary-500 font-normal">
				Gemeinschaftsschule Loßburg
			</span>
			<br />
			Eine starke Schule für alle.
		</nk-title>

		<nk-row vertical-gutter="2">
			<nk-col cols="full" sm="auto">
				<nk-card :grouped="false">
					<template #header>
						<nk-link
							block
							link="/de/gemeinschaftsschule/bildungspartnerschaft/"
							tabindex="-1"
						>
							<nk-image
								src="/static-images/gemeinschaftsschule/schule-unterricht.jpg"
								alt="Kinder am Tisch mit Lötgerät"
								ar="21:9"
							/>
						</nk-link>
					</template>
					<template #body>
						<nk-link
							block
							link="/de/gemeinschaftsschule/bildungspartnerschaft/"
							tabindex="-1"
						>
							<nk-title size="xl">Kooperationen</nk-title>
						</nk-link>
						<nk-text>
							Durch zahlreiche Kooperationen mit Betrieben wie der Firma Arburg
							und weiteren Partnern aus den unterschiedlichsten Bereichen bahnen
							wir den Jugendlichen ebenfalls den Weg in eine erfolgreiche
							Ausbildung.
						</nk-text>
						<nk-button
							variant="link"
							size="collapse"
							append-icon="arrow-right"
							link="/de/gemeinschaftsschule/bildungspartnerschaft/"
						>
							Bildungspartnerschaft
						</nk-button>
					</template>
				</nk-card>
			</nk-col>

			<nk-col cols="full" sm="auto">
				<nk-card :grouped="false">
					<template #header>
						<nk-link
							block
							link="/de/gemeinschaftsschule/leitbild/"
							tabindex="-1"
						>
							<nk-image
								src="/static-images/gemeinschaftsschule/kinder-schulsanitaeter.jpeg"
								alt="Kinder zu Besuch beim Schulsanitäter"
								ar="21:9"
							/>
						</nk-link>
					</template>
					<template #body>
						<nk-link
							block
							link="/de/gemeinschaftsschule/leitbild/"
							tabindex="-1"
						>
							<nk-title size="xl">Stark für alle!</nk-title>
						</nk-link>
						<nk-text>
							Bewährtes aus der Realschule wird fort­geführt, das Lernen wird in
							zeit­ge­mäßen Formen neu gestaltet. Lernen ist auf allen 3
							Niveaustufen möglich. Regel­mäßige Coaching­gespräche wahren einen
							engen Bezug zwischen Lehrern und Schülern.
						</nk-text>
						<nk-button
							variant="link"
							size="collapse"
							append-icon="arrow-right"
							link="/de/gemeinschaftsschule/leitbild/"
						>
							Unser Leitbild
						</nk-button>
					</template>
				</nk-card>
			</nk-col>
			<nk-col cols="full" sm="auto">
				<nk-card :grouped="false">
					<template #header>
						<nk-link
							block
							link="/de/gemeinschaftsschule/schulportrait/"
							tabindex="-1"
						>
							<nk-image
								src="/static-images/gemeinschaftsschule/unterricht-bio.jpg"
								alt="Bio Unterricht"
								ar="21:9"
							/>
						</nk-link>
					</template>
					<template #body>
						<nk-link
							block
							link="/de/gemeinschaftsschule/schulportrait/"
							tabindex="-1"
						>
							<nk-title size="xl">Weg zum Abitur</nk-title>
						</nk-link>
						<nk-text>
							Traditionell nutzen viele Schülerinnen und Schüler auch mit der
							Grundschulempfehlung für Gymnasium den „sanften Weg“ zum Abitur.
							Viele unserer ehemaligen Schüler/innen haben diesen Weg schon
							erfolgreich eingeschlagen.
						</nk-text>
						<nk-button
							variant="link"
							size="collapse"
							append-icon="arrow-right"
							link="/de/gemeinschaftsschule/schulportrait/"
						>
							Schulportrait
						</nk-button>
					</template>
				</nk-card>
			</nk-col>
		</nk-row>

		<nk-divider />

		<nk-title size="xl" tag="h2">Aktuelles aus unserer Schule</nk-title>
		<nk-row vertical-gutter="2">
			<nk-col cols="full" md="6/12">
				<nk-title size="lg" tag="h3">Berichte</nk-title>
				<template v-if="context.artikel && context.artikel.length">
					<article
						v-for="(artikel, artikelIndex) in context.artikel"
						:key="artikelIndex"
						class="mb-3 pb-3 border-b border-border last:border-0"
					>
						<nk-text no-margin>
							{{ $formatTime(artikel.datum_von) }}
						</nk-text>
						<nk-text>
							<nk-link :link="artikel.detailURL">
								{{ artikel.titel }}
							</nk-link>
						</nk-text>
					</article>
				</template>
				<nk-text v-else>Aktuell sind keine Berichte erfasst</nk-text>
			</nk-col>
			<nk-col cols="full" md="6/12">
				<nk-title size="lg" tag="h3">Veranstaltungen</nk-title>
				<template
					v-if="context.veranstaltungen && context.veranstaltungen.length"
				>
					<article
						v-for="(
							veranstaltung, veranstaltungIndex
						) in context.veranstaltungen"
						:key="veranstaltungIndex"
						class="mb-3 pb-3 border-b border-border last:border-0"
					>
						<nk-text no-margin>
							{{
								$getDateTimeString({
									dateFrom: veranstaltung.datum_von,
									dateTo: veranstaltung.datum_bis,
								})
							}}
						</nk-text>
						<nk-text v-if="veranstaltung.rubriken[0].detailURL">
							<nk-link :link="veranstaltung.rubriken[0].detailURL">
								{{ veranstaltung.titel }}
							</nk-link>
						</nk-text>
						<nk-text v-else>
							{{ veranstaltung.titel }}
						</nk-text>
					</article>
				</template>
				<nk-text v-else>Aktuell sind keine Veranstaltungen erfasst</nk-text>
			</nk-col>
		</nk-row>
	</div>
</template>

<script>
/**
 * @prop {string} context.aktuelles
 * @prop {array} context.veranstaltungen
 */
import TemplatesDefault from '#nk/mixins/templates-default';

export default {
	name: 'TemplateGemeinschaftsschule',

	mixins: [TemplatesDefault],
};
</script>
